export default ($http) => ({
  fetchAtlasMessage () {
    return $http.get('message-board-default')
  },
  fetchAtlasMessageDraft () {
    return $http.get('message-board-default/draft')
  },
  publishAtlasMessage () {
    return $http.put('message-board-default')
  },
  saveAtlasMessageDraft (payload) {
    return $http.put('message-board-default/draft', { body: payload })
  },
  fetchIdps () {
    return $http.get('idp')
  },
  fetchDirectories(url = '') {
    return $http.get('directories' + (url ? `?url=${url}` : ''))
  },
  fetchIdp (provider) {
    return $http.get(`idp/${provider}`)
  },
  createIdp (provider, config = null, newUri = null) {
    return $http.post('idp', { body: { config, newUri, provider } })
  },
  updateIdp (provider, config = null, newUri = null, oldUri = null) {
    return $http.put(`idp/${provider}`, { body: { config, newUri, oldUri } })
  },
  deleteIdp (provider) {
    return $http.delete(`idp/${provider}`)
  },
  fetchLessonPlanningSettings() {
    return $http.get('lesson-planner-settings')
  },
  updateLessonPlanningSettings(payload) {
    return $http.put('lesson-planner-settings', { body: payload })
  },
  syncListToManageBac(payload) {
    return $http.post('sync-list-to-managebac', { body: payload })
  }
})
